import React from 'react';
import clsx from 'clsx';
import { AlertCircle, CheckCircle, Info, AlertTriangle } from 'lucide-react';
import styles from './Message.module.css';

export interface MessageProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'error' | 'success' | 'info' | 'warning';
  icon?: React.ReactNode;
  children: React.ReactNode;
}

const Message: React.FC<MessageProps> = ({
  variant = 'error',
  icon,
  children,
  className,
  ...props
}) => {
  const defaultIcon = {
    error: <AlertCircle size={20} />,
    success: <CheckCircle size={20} />,
    info: <Info size={20} />,
    warning: <AlertTriangle size={20} />
  }[variant];

  return (
    <div
      className={clsx(
        styles.message,
        styles[variant],
        className
      )}
      {...props}
    >
      {icon !== undefined ? icon : defaultIcon}
      {children}
    </div>
  );
};

export default Message;
